import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col items-center justify-center p-6 text-center font-sans">
      <div className="max-w-md w-full bg-slate-900 border border-slate-800 rounded-3xl p-8 shadow-2xl space-y-6">
        <div className="w-20 h-20 bg-gradient-to-tr from-red-600 via-orange-500 to-amber-500 rounded-3xl flex items-center justify-center mx-auto shadow-lg shadow-orange-500/20 text-3xl font-black text-white">
          404
        </div>
        
        <div>
          <h1 className="text-2xl md:text-3xl font-black text-white">Page Not Found</h1>
          <p className="text-slate-400 text-sm mt-2 leading-relaxed">
            The page or verification route you are looking for doesn't exist or has been relocated on the Verisure platform.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 pt-2">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="flex-1 bg-slate-800 hover:bg-slate-700 text-slate-200 border border-slate-700 font-bold py-3 rounded-xl transition text-xs"
          >
            &larr; Go Back
          </button>
          <Link
            to="/"
            className="flex-1 bg-gradient-to-r from-red-600 via-orange-500 to-amber-500 text-white font-bold py-3 rounded-xl shadow-lg shadow-orange-500/20 hover:opacity-95 transition text-xs"
          >
            Return Home
          </Link>
        </div>

        <div className="pt-4 border-t border-slate-800 flex justify-center gap-4 text-xs text-slate-500">
          <Link to="/items" className="hover:text-orange-400 transition">Asset Registry</Link>
          <span>&bull;</span>
          <Link to="/technicians" className="hover:text-orange-400 transition">Technicians</Link>
          <span>&bull;</span>
          <Link to="/about" className="hover:text-orange-400 transition">About</Link>
        </div>
      </div>
    </div>
  );
};
